const CapabilitiesAssignmentModule = () => import('@pages/core/security/CapabilitiesAssignmentModule.vue')
const CapabilitiesAssignmentIndex = () => import('@pages/core/security/CapabilitiesAssignmentIndex.vue')
const MenuItemAssignmentIndex = () => import('@pages/security/MenuItemAssignmentIndex.vue')

export default {
    path: 'security',
    component: CapabilitiesAssignmentModule,
    children: [
        {
            path: 'capabilities-assignment-index',
            component: CapabilitiesAssignmentIndex,
            name: 'capabilitiesAssignmentPage',
        },
        {
            path: 'menu-item-assignment-index',
            component: MenuItemAssignmentIndex,
            name: 'menuItemAssignmentPage',
        },
    ],
}
